import script from "./GlobusCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusCalendar.vue?vue&type=script&setup=true&lang=js"

import "./GlobusCalendar.vue?vue&type=style&index=0&id=f3b42cf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3b42cf0"]])

export default __exports__